module.exports = __webpack_public_path__ + "media/images/icon/icons8-Login-a888bfd3e13f2e278f2c8e91bcdd2e1e.png";